import ModuleTabs from '@/components/common/ModuleTab';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { PairMap } from '@/state/reducers/marketPairSlice';
import { selectOrderBookWorkspace, setOrderBookWorkspace } from '@/state/reducers/workspaceSlice';
import useLanguage from '@/utils/hooks/useLanguage';
import { useDebouncedSize } from '@/utils/hooks/useSize';
import { Tab } from '@headlessui/react';
import { useMemo, useRef } from 'react';
import HorizontalBook from './HorizontalBook';
import VerticalBook from './VerticalBook';

export interface OrderBookProps {
    instrument: PairMap;
    parentSize?: number;
}

export default function OrderBook(props: OrderBookProps) {
    const { instrument } = props;

    const dispatch = useAppDispatch();
    const orderBookWorkspace = useAppSelector(selectOrderBookWorkspace);

    const orderBookBodyRef = useRef<HTMLDivElement>(null);
    const size = useDebouncedSize(orderBookBodyRef);

    const lang = useLanguage();

    const tabs = useMemo(() => {
        return [lang.orderBook.vertical, lang.orderBook.horizontal];
    }, [lang]);

    // useEffect(() => {
    //     if ((size?.width || 0) > 600 && orderBookWorkspace !== 'Horizontal') {
    //         dispatch(setOrderBookWorkspace('Horizontal'));
    //     } else if ((size?.width || 0) <= 600 && orderBookWorkspace !== 'Vertical') {
    //         dispatch(setOrderBookWorkspace('Vertical'));
    //     }
    // }, [size]);

    return (
        <Tab.Group
            defaultIndex={tabs.findIndex((tab) => tab === orderBookWorkspace)}
            selectedIndex={tabs.findIndex((tab) => tab === orderBookWorkspace)}
            onChange={(index) => dispatch(setOrderBookWorkspace(index === 0 ? 'Vertical' : 'Horizontal'))}>
            <div ref={orderBookBodyRef} className="h-full flex flex-col" dir={lang.dir}>
                <ModuleTabs.Main tabs={tabs} />
                <Tab.Panel className="flex-1 flex flex-col bg-brand-background overflow-auto">
                    <VerticalBook instrument={instrument} />
                </Tab.Panel>
                <Tab.Panel className="flex-1 flex flex-col bg-brand-background overflow-auto">
                    <HorizontalBook instrument={instrument} parentSize={size?.width || 0} />
                </Tab.Panel>
            </div>
        </Tab.Group>
    );
}

// import { useAppDispatch, useAppSelector } from '@/state/hooks';
// import { PairMap } from '@/state/reducers/marketPairSlice';
// import { selectOrderBookWorkspace, setOrderBookWorkspace } from '@/state/reducers/workspaceSlice';
// import useLanguage from '@/utils/hooks/useLanguage';
// import { useDebouncedSize } from '@/utils/hooks/useSize';
// import { useEffect, useRef } from 'react';
// import HorizontalBook from './HorizontalBook';
// import VerticalBook from './VerticalBook';

// export interface OrderBookProps {
//     instrument: PairMap;
//     parentSize?: number;
// }

// export default function OrderBook(props: OrderBookProps) {
//     const { instrument } = props;

//     const dispatch = useAppDispatch();
//     const orderBookWorkspace = useAppSelector(selectOrderBookWorkspace);

//     const orderBookBodyRef = useRef<HTMLDivElement>(null);
//     const size = useDebouncedSize(orderBookBodyRef);

//     const lang = useLanguage();

//     useEffect(() => {
//         if ((size?.width || 0) > 600 && orderBookWorkspace !== 'Horizontal') {
//             dispatch(setOrderBookWorkspace('Horizontal'));
//         } else if ((size?.width || 0) <= 600 && orderBookWorkspace !== 'Vertical') {
//             dispatch(setOrderBookWorkspace('Vertical'));
//         }
//     }, [size]);

//     return (
//         <div ref={orderBookBodyRef} className="h-full flex flex-col" dir={lang.dir}>
//             {orderBookWorkspace === 'Vertical' && (
//                 <div className="flex-1 flex flex-col bg-brand-background overflow-auto">
//                     <VerticalBook instrument={instrument} />
//                 </div>
//             )}
//             {orderBookWorkspace === 'Horizontal' && (
//                 <div className="flex-1 flex flex-col bg-brand-background overflow-auto">
//                     <HorizontalBook instrument={instrument} parentSize={size?.width || 0} />
//                 </div>
//             )}
//         </div>
//     );
// }
